import React, { useState } from "react";
import appIcon from "../../assets/images/logo/principal-app-icon.png";

/*
 * On-device preview, mirroring the preview panel of the Firebase console.
 * Indicative only — the real thing depends on the OS and the app version.
 *
 * Two previews:
 *  - "push"  : the OS notification popup (Android / iOS), shown outside the app.
 *  - "inapp" : inside the app — a home screen with a notification bell that opens
 *              the (not-yet-built) notification list page, a blank white screen for now.
 */
function DevicePreview({ title, body, imageUrl }) {
  const [mode, setMode] = useState("push");
  const [platform, setPlatform] = useState("android");
  const [inappStep, setInappStep] = useState("home");

  const previewTitle = title || "Notification title";
  const previewBody = body || "Notification message will show here";

  const hideOnError = event => {
    event.target.style.display = "none";
  };
  const hideIconOnError = event => {
    event.target.style.visibility = "hidden";
  };

  const bellIcon = (
    <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9" />
      <path d="M13.73 21a2 2 0 0 1-3.46 0" />
    </svg>
  );

  const avatarIcon = (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
      <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10zm0 2c-4.42 0-8 2.24-8 5v1h16v-1c0-2.76-3.58-5-8-5z" />
    </svg>
  );

  const messageIcon = (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
    </svg>
  );

  return (
    <div className="push-noti-preview">
      <div className="push-noti-preview-modetabs">
        <button
          type="button"
          className={mode === "push" ? "push-noti-preview-modetab active" : "push-noti-preview-modetab"}
          onClick={() => setMode("push")}
        >
          Out-of-app
        </button>
        <button
          type="button"
          className={mode === "inapp" ? "push-noti-preview-modetab active" : "push-noti-preview-modetab"}
          onClick={() => setMode("inapp")}
        >
          In-app
        </button>
      </div>

      <div className="push-noti-preview-tabs">
        <button
          type="button"
          className={platform === "android" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("android")}
        >
          ANDROID
        </button>
        <button
          type="button"
          className={platform === "ios" ? "push-noti-preview-tab active" : "push-noti-preview-tab"}
          onClick={() => setPlatform("ios")}
        >
          iOS
        </button>
      </div>

      {mode === "push" ? (
        <div className="push-noti-preview-device">
          <div className="push-noti-preview-screen">
            {/* Android reuses the iOS card layout for now. */}
            <div className="push-noti-card push-noti-card-ios">
              <img className="push-noti-card-ios-icon" src={appIcon} alt="" onError={hideIconOnError} />
              <div className="push-noti-card-ios-main">
                <div className="push-noti-card-ios-head">
                  <p className="push-noti-card-title">{previewTitle}</p>
                  <span className="push-noti-card-time">now</span>
                </div>
                <p className="push-noti-card-body">{previewBody}</p>
                {imageUrl ? (
                  <img className="push-noti-card-image" src={imageUrl} alt="notification" onError={hideOnError} />
                ) : null}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="push-noti-inapp-device">
          {inappStep === "home" ? (
            <div className="push-noti-inapp-screen">
              <div className="push-noti-inapp-hero">
                <div className="push-noti-inapp-hero-user">
                  <span className="push-noti-inapp-avatar">{avatarIcon}</span>
                  <div className="push-noti-inapp-greet">
                    <span className="push-noti-inapp-greet-hello">สวัสดี</span>
                    <span className="push-noti-inapp-greet-sub">เข้าสู่ระบบครั้งล่าสุด 24/09/2026 13:27</span>
                  </div>
                </div>
                <button
                  type="button"
                  className="push-noti-inapp-bell"
                  onClick={() => setInappStep("list")}
                  aria-label="Open notifications"
                >
                  {bellIcon}
                  <span className="push-noti-inapp-bell-badge">1</span>
                </button>
              </div>
              <div className="push-noti-inapp-menu">
                <div className="push-noti-inapp-menu-box" />
                <div className="push-noti-inapp-menu-box" />
              </div>
            </div>
          ) : (
            <div className="push-noti-inapp-screen">
              <div className="push-noti-inapp-appbar">
                <button
                  type="button"
                  className="push-noti-inapp-back"
                  onClick={() => setInappStep("home")}
                  aria-label="Back"
                >
                  &#8249;
                </button>
                <span className="push-noti-inapp-appbar-title">การแจ้งเตือน</span>
                <span className="push-noti-inapp-appbar-spacer" />
              </div>
              <div className="push-noti-inapp-list">
                <button type="button" className="push-noti-inapp-readall">อ่านทั้งหมดแล้ว</button>
                <div className="push-noti-inapp-listitem">
                  <span className="push-noti-inapp-listitem-icon">{messageIcon}</span>
                  <div className="push-noti-inapp-listitem-main">
                    <p className="push-noti-inapp-listitem-title">{previewTitle}</p>
                    <p className="push-noti-inapp-listitem-body">{previewBody}</p>
                    <span className="push-noti-inapp-listitem-time">1 นาทีที่แล้ว</span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      <p className="push-noti-preview-note">
        {mode === "inapp" && inappStep === "home"
          ? "Tap the bell to open the notification page"
          : "Preview for rough layout only"}
      </p>
    </div>
  );
}

export default DevicePreview;
